import { AbilityBuilder, Ability } from '@casl/ability'

export const ability = new Ability();

export const abilityPlugin = (store) => {
    return store.subscribe((mutation) => {
        if (mutation.type === 'SIGN_IN') {
            if(mutation.payload.role)ability.update(defineAbilitiesFor(mutation.payload.role).rules);
        }
    })
};

function defineAbilitiesFor(type) {
    return AbilityBuilder.define(can => {
        switch(type) {
            case 'mechanic':
                can('be', 'mechanic');
                break;
            case 'dealer':
                can('be', 'dealer');
                break;
            case 'broker':
              can('be', 'broker');
              break;
            case 'garden':
              can('be', 'garden');
              break;
            case 'mutuaide':
              can('be', 'mutuaide');
              break;
          case 'mutuaide_representative':
            can('be', 'mutuaide_representative');
            break;
            case 'driving_school':
                can('be', 'driving_school');
                break;
            case 'representative':
                can('be', 'representative');
                can(['read'], 'account_representative');
                break;
        }
    });
}



// WEBPACK FOOTER //
// ./src/abilities.js